export var AccountUpgradeModalTypeEnum;
(function (AccountUpgradeModalTypeEnum) {
    AccountUpgradeModalTypeEnum["General"] = "General";
    AccountUpgradeModalTypeEnum["SpeakersCount"] = "SpeakersCount";
    AccountUpgradeModalTypeEnum["Integrations"] = "Integrations";
    AccountUpgradeModalTypeEnum["Reseller"] = "Reseller";
    AccountUpgradeModalTypeEnum["GoogleDrive"] = "GoogleDrive";
    AccountUpgradeModalTypeEnum["Export"] = "Export";
})(AccountUpgradeModalTypeEnum || (AccountUpgradeModalTypeEnum = {}));
